import React from 'react';
// import logo from './logo.svg';
import './App.css';


// import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import ErrorPage from "./error-page";
import Index from "./pages/index";
import Foods from "./pages/foods";
import FoodDetail from "./pages/food-detail";
import Ingredients from "./pages/ingredients";
import MenuConfigure from "./pages/menu-configure";
import AdminIngredients from "./pages/admin-ingredients";
import AdminUsers from "./pages/admin-users";
import AdminFeedback from "./pages/admin-feedback";
import Feedback from "./pages/feedback";
import Login from "./pages/login";
import Register from "./pages/register";
import ConfirmEmail from "./pages/confirm-email";
import Layout from "./Layout";




const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      // Public routes
      {
        index: true,
        element: <Index />,
      },
      {
        path: "/menu",
        element: <Index />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/confirm-email",
        element: <ConfirmEmail />,
      },
      // Private routes - require authentication
      {
        path: "/feedback",
        element: <PrivateRoute><Feedback /></PrivateRoute>,
      },
      {
        path: "/foods",
        element: <PrivateRoute><Foods /></PrivateRoute>,
      },
      {
        path: "/foods/:id",
        element: <PrivateRoute><FoodDetail /></PrivateRoute>,
      },
      {
        path: "/ingredients",
        element: <PrivateRoute><Ingredients /></PrivateRoute>,
      },
      {
        path: "/menu/configure",
        element: <PrivateRoute><MenuConfigure /></PrivateRoute>,
      },
      {
        path: "/admin/ingredients",
        element: <PrivateRoute><AdminIngredients /></PrivateRoute>,
      },
      {
        path: "/admin/users",
        element: <PrivateRoute><AdminUsers /></PrivateRoute>,
      },
      {
        path: "/admin/feedback",
        element: <PrivateRoute><AdminFeedback /></PrivateRoute>,
      },
    ],
  },
]);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
